import React, { memo } from 'react';
import './Filters/Filters.css';
import MultipleSelect from './MultipleSelect';
import { useIgdFiltersContext } from './Filters/hooks/useIgdFiltersContext';

const CityFilter = ({ className = '' }) => {
    const { filters, cities, onFilterChange } = useIgdFiltersContext();

    return (
        <div className={`filtros-container-dashboards ${className}`}>
            <MultipleSelect
                label="Cidade"
                options={cities}
                onChange={onFilterChange}
                name="cidade"
                className="select-cidade-dashboards"
                defaultValue={filters.cidade}
            />
        </div>
    );
};

export default memo(CityFilter);
